// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tjMZ6OiexJHdILHvcdM6 {
  display: block;
  line-height: 1.5;
}

.HRqXmBrRwP8KIkPdq9hB {
  display: block;
  line-height: 1.5;
  margin-left: 16px;
}

.knK9HKI4PbLRvuNdIGTF {
  color: #777679 !important;
  cursor: default;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/waitlist-update/process-removals/components/index.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB","sourcesContent":[".sideBarItem {\n  display: block;\n  line-height: 1.5;\n}\n\n.sideBarItemSmall {\n  display: block;\n  line-height: 1.5;\n  margin-left: 16px;\n}\n\n.disabled {\n  color: #777679 !important;\n  cursor: default;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideBarItem": `tjMZ6OiexJHdILHvcdM6`,
	"sideBarItemSmall": `HRqXmBrRwP8KIkPdq9hB`,
	"disabled": `knK9HKI4PbLRvuNdIGTF`
};
export default ___CSS_LOADER_EXPORT___;
